import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';
import { Subject, takeUntil } from 'rxjs';
import { HoursOption } from '../../shared/models/hours-option';
import { Registration } from '../../shared/models/registration';
import { ToolbarService } from '../../shared/services/toolbar.service';
import { WorkerAndToolService } from '../../shared/services/worker-and-tool.service';

import { alert } from 'devextreme/ui/dialog';
import { RegistrationWorkflowService, WorkflowContext } from '../../shared/services/registration-workflow.service';

@Component({
    selector: 'app-registration-drivers-kilometers',
    templateUrl: './registration-drivers-kilometers.component.html',
    styleUrls: ['./registration-drivers-kilometers.component.scss'],
    standalone: false
})
export class RegistrationDriversKilometersComponent {
  @ViewChild(DxDataGridComponent) dataGrid?: DxDataGridComponent;

  registration!: Registration | undefined;
  option: HoursOption | any;

  kmEditorOptions: object;
  hasControls = false;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private service: WorkerAndToolService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router,
    private workflowService: RegistrationWorkflowService) {

    this.kmEditorOptions = {
      mode: 'number',
      showSpinButtons: false
    }

    this.registration = service.getNewRegistration();
  }

  onEditorPreparing(e: EditorPreparingEvent) {
    if (e.dataField === "km" && e.parentType === "dataRow") {
      e.editorOptions.onFocusIn = (function (args: { element: { querySelector: (arg0: string) => { (): any; new(): any; select: { (): void; new(): any; }; }; }; }): void {
        console.log(args.element);
        args.element.querySelector(".dx-texteditor-input").select();
      })
    }
  }

  ngOnInit() {
    this.service.getHoursOptionObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.option = val;
    });

    this.toolbar.backClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Back());
    this.toolbar.forwardClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Forward());

    this.toolbar.BackVisibleChanged(true);
    this.toolbar.SaveVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(true);
    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);

    let regId = this.route.snapshot.paramMap.get('id');

    if (regId == null) {
      regId = "-1";
    }

    this.service.getTempRegistration(Number(regId)).then((reg) => {
      this.registration = reg;
      if (this.registration) {
        this.service.getHasControls(this.registration).then(c => { this.hasControls = c; })
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  async Forward() {
    // commit di eventuali edit pendenti (cella "km" ancora in editing)
    await this.dataGrid?.instance.saveEditData();

    if (this.registration) {
      const ctx: WorkflowContext = { options: this.option, siteManagerMode: true, hasControls: this.hasControls };

      if (this.workflowService.isFinalStep('registration-drivers-kilometers', ctx)) {
        this.registration.id ??= 0;
        if (this.registration.id > 0) {
          this.service.editRegistration(this.registration, this.registration.id)
            .then(() => this.router.navigate(['/registrations']))
            .catch(err => { if (!this.service.showSaveError(err)) throw err; });
        } else {
          this.service.addRegistration(this.registration)
            .then(() => this.router.navigate(['/registrations']))
            .catch(err => { if (!this.service.showSaveError(err)) throw err; });
        }
      } else {
        this.service.editTempRegistration(this.registration, this.registration.id ?? 0)
          .then((regId) => {
            const next = this.workflowService.getNextStep('registration-drivers-kilometers', ctx);
            this.router.navigate(['/' + next, { id: regId }]);
          });
      }
    }
    else {
      alert("Nessuna registrazione individuata", "Errore");
    }
  }

  Back() {
    this.router.navigate(['/registration-drivers-select', { id: this.registration?.id }]);
  }
}
